import {openModal} from "../Actions";
import AccessKeysModal from './index';

export const openEditKeysModal = () => openModal(AccessKeysModal);
